import { useParams } from "react-router";
import { Card } from "../components/ui/Card";
import { CheckoutForm } from "../components/checkout/CheckoutForm";
import { marketplaceService } from "../services/marketplaceService";

export function CheckoutPage() {
  const { listingId = "lst-ozempic" } = useParams();
  const listing = marketplaceService.getListing(listingId);
  return (
    <Card className="p-8">
      <p className="text-xs font-black uppercase tracking-[.28em] text-slate-500">Checkout</p>
      <h1 className="mt-3 text-4xl font-black">Buy, hold, or bid on {listing.name}</h1>
      <CheckoutForm listing={listing} />
    </Card>
  );
}
